export namespace Url {
    export function parseSearchString(searchString: string): { [key: string]: string | undefined } {
        if (searchString.length < 1) {
            return {};
        }
        return searchString
            .replace(/^\?/, '')
            .split('&')
            .reduce((params, param) => {
                const [key, value] = param.split('=');
                return { ...params, [decodeURIComponent(key)]: decodeURIComponent(value) };
            }, {});
    }

    export function updateSearchString(searchString: string, key: string, value: string): string {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value);
        const combinedKeyValue = encodedKey + '=' + encodedValue;

        if (searchString.includes(encodedKey + '=')) {
            return searchString.replace(new RegExp(`${key}=[^&]*`), combinedKeyValue);
        } else if (searchString.includes('?')) {
            return searchString + '&' + combinedKeyValue;
        } else {
            return searchString + '?' + combinedKeyValue;
        }
    }

    export function bulkUpdateSearchString(searchString: string, values: { [key: string]: string }): string {
        return Object.keys(values).reduce((search, key) => updateSearchString(search, key, values[key]), searchString);
    }
}



// WEBPACK FOOTER //
// ./src/util/Url.ts